import { OrientationType, ResolutionType, useScreenStore } from "application/contexts/screen/ScreenStore";
import React, { FC } from "react";
import styles from "../../../offlineRecharge/OfflineRecharge.module.scss";

/** Indicador das 3 etapas: 1-Leitura, 2-Dados/Valor, 3-Gravação */
export interface StepIndicatorProps {
  /** Índice da etapa atual (0, 1 ou 2) */
  currentStepIndex: number;
}

export const StepIndicator: FC<StepIndicatorProps> = ({ currentStepIndex }) => {
  const { resolution, orientation } = useScreenStore();
  const isLandscape = orientation === OrientationType.LANDSCAPE;

  return (
    <div
      className={styles.stepContainer}
      style={{
        margin: resolution === ResolutionType.FULL_HD ? "16px 0" : isLandscape ? "2px 0" : "6px 0",
        fontSize: resolution === ResolutionType.FULL_HD ? 32 : isLandscape ? 16 : 22,
      }}
    >
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{
            minWidth: resolution === ResolutionType.FULL_HD ? 100 : isLandscape ? 52 : 72,
            height: resolution === ResolutionType.FULL_HD ? 64 : isLandscape ? 30 : 44,
          }}
          className={currentStepIndex === i ? styles.selected : undefined}
        >
          {i + 1}
        </div>
      ))}
    </div>
  );
};
